import types from "../index";

function setSubscription(subscription) {
    return {
        subscription,
        type: types.PURCHASE_SET_SUBSCRIPTION,
    }
}

function setAddons(addons) {
    return {
        addons,
        type: types.PURCHASE_SET_ADDONS,
    }
}

function setAmount(amount) {
    return {
        amount,
        type: types.PURCHASE_SET_AMOUNT,
    }
}

function addAddon(addon) {
    return {
        addon,
        type: types.PURCHASE_ADD_ADDON,
    }
}
function removeAddon(addon) {
    return {
        addon,
        type: types.PURCHASE_REMOVE_ADDON,
    }
}

const actions = {
    setSubscription,
    setAddons,
    setAmount,
    addAddon,
    removeAddon,
}

export default actions;
